import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Lot } from '../../../common/model/dto/lot';
import { OrderBy } from '../../../common/types';
import { useLotListColumns } from '../../../hooks/use-lot-list-columns';
import { useRouteUrl } from '../../../hooks/use-route-url';
import OvRecordList from './OvRecordList';

interface OvLotListProps {
  lots: Lot[];
  orderBy: string;
  orderDir: string;
  onSort: (order: OrderBy) => void;
}

const OvLotList: FC<OvLotListProps> = ({ lots, orderBy, orderDir, onSort }) => {
  const { t } = useTranslation();
  const url = useRouteUrl();
  const columns = useLotListColumns();

  return (
    <OvRecordList
      label={t('lots.title')}
      records={lots}
      columns={columns}
      getKey={(lot) => lot.id ?? ''}
      getDetailsPath={(lot) => `${url}/${lot.id}`}
      orderBy={orderBy}
      orderDir={orderDir}
      onSort={onSort}
    />
  );
};

export default OvLotList;
